import config from "@/config";
import http from "@/utils/request";

export default {
	model: {
		list: {
			url: `${config.MAIN_URL}/admin/api/company/private/model`,
			name: "企业机型模型列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		save: {
			url: `${config.MAIN_URL}/admin/api/company/private/model`,
			name: "企业机型模型新增修改",
			post: async function (params) {
				return await http.post(this.url, params);
			},
			put: async function (params) {
				return await http.put(this.url, params);
			},
		},
		delete: {
			url: `${config.MAIN_URL}/admin/api/company/private/model`,
			name: '企业机型模型删除',
			delete: async function (params) {
				return await http.delete(this.url + params);
			},
		},
	},
	aircraft: {
		list: {
			url: `${config.MAIN_URL}/admin/api/company/private/num`,
			name: "企业机航空器列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		save: {
			url: `${config.MAIN_URL}/admin/api/company/private/num`,
			name: "企业机航空器新增修改",
			post: async function (params) {
				return await http.post(this.url, params);
			},
			put: async function (params) {
				return await http.put(this.url, params);
			},
		},
		delete: {
			url: `${config.MAIN_URL}/admin/api/company/private/num`,
			name: '企业机航空器删除',
			delete: async function (params) {
				return await http.delete(this.url + params);
			},
		},
		select: {
			url: `${config.MAIN_URL}/admin/api/model/select`,
			name: '企业机型下拉',
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		publicSelect: {
			url: `${config.NAIP_URL}/common/api/aircraft`,
			name: "公共机型下拉",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		model: {
			url: `${config.MAIN_URL}/admin/api/num`,
			name: "企业机型模型获取",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		publicModel: {
			url: `${config.NAIP_URL}/common/api/aircraft/detail`,
			name: "公共模型获取",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	information: {
		list: {
			url: `${config.MAIN_URL}/api/v1/company/data`,
			name: "航空器资料列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		save: {
			url: `${config.MAIN_URL}/api/v1/company/data`,
			name: "航空器资料新增",
			post: async function (params) {
				return await http.post(this.url, params);
			},
			put: async function (params) {
				return await http.put(this.url, params);
			},
		},
		delete: {
			url: `${config.MAIN_URL}/api/v1/company/data`,
			name: '航空器资料删除',
			delete: async function (params) {
				return await http.delete(this.url + params);
			},
		},
		layout: {
			url: `${config.MAIN_URL}/admin/api/company/private/layout`,
			name: '航空器查询布局',
			get: async function (params) {
				return await http.get(this.url , params);
			},
		},
	},
};
